import isEqual from 'lodash-es/isEqual';

import type { ReportMetric } from '@/shared/types/reports';

export type EditedMetricRef = {
  index: number;
  original: ReportMetric;
  metricsCount: number;
  /** Whether another slot held an identical metric when the editor opened. */
  duplicated: boolean;
};

export const makeMetricRef = (metrics: ReportMetric[], index: number): EditedMetricRef => ({
  index,
  original: metrics[index],
  metricsCount: metrics.length,
  duplicated: metrics.some((metric, i) => i !== index && isEqual(metric, metrics[index])),
});

export const resolveMetricIndex = (
  metrics: ReportMetric[],
  { index, original, metricsCount, duplicated }: EditedMetricRef
): number => {
  if (isEqual(metrics[index], original)) {
    return index;
  }
  if (!duplicated) {
    const matched = metrics.findIndex((metric) => isEqual(metric, original));
    if (matched !== -1) {
      return matched;
    }
  }
  if (metrics.length === metricsCount && index < metrics.length) {
    return index;
  }
  return -1;
};
